import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "frame-1" }
const _hoisted_2 = { class: "estados" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "ellipse" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "title-graph" }, "Em espera: ", -1)
const _hoisted_5 = { class: "percentage-button" }
const _hoisted_6 = { class: "percentage-span" }
const _hoisted_7 = { class: "states-div" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "ellipse-div" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "title-graph" }, "Em andamento: ", -1)
const _hoisted_10 = { class: "percentage" }
const _hoisted_11 = { class: "percentage-span" }
const _hoisted_12 = { class: "states" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "ellipse-2" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "title-graph" }, "Concluídos: ", -1)
const _hoisted_15 = { class: "percentage-button-3" }
const _hoisted_16 = { class: "percentage-span" }
const _hoisted_17 = { class: "graph-div" }

import Vue3ChartJs from '@j-t-mcc/vue3-chartjs';
import { onMounted, ref, watch } from 'vue';
import { IDataset } from '../../types';

interface IProps {
  data: IDataset;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'AtomChartPie',
  props: {
    data: {}
  },
  setup(__props: any) {

const props = __props;
const computedStyles = getComputedStyle(document.documentElement);
const secondaryC400 = computedStyles.getPropertyValue('--secondary-c400');
const secondaryC600 = computedStyles.getPropertyValue('--secondary-c600');
const secondaryC800 = computedStyles.getPropertyValue('--secondary-c800');

const chart = ref({
  type: 'pie',
  data: {
    labels: ['Serviços Aguardando', 'Serviços em Andamento', 'Serviços Finalizados'],
    datasets: [
      {
        backgroundColor: [secondaryC400, secondaryC600, secondaryC800],
        data: [props.data.servicesWaiting, props.data.servicesRunning, props.data.servicesFinished],
        hoverBorderWidth: 5,
        borderRadius: 5,
      },
    ],
  },
  options: {
    animation: {
      animateScale: true,
      animateRotate: true,
    },
    legend: {
      display: false,
    },
    plugins: {
      legend: {
        display: false,
      },
    },
    tooltips: {
      callbacks: {
        label: function (tooltipItem) {
          return tooltipItem.yLabel;
        },
      },
    },
  },
});

watch(
  () => props,
  () => {
    chart.value = {
      type: 'doughnut',
      data: {
        labels: ['Serviços Aguardando', 'Serviços em Andamento', 'Serviços Finalizados'],
        datasets: [
          {
            backgroundColor: [secondaryC400, secondaryC600, secondaryC800],
            data: [props.data.servicesWaiting, props.data.servicesRunning, props.data.servicesFinished],
            hoverBorderWidth: 8,
            offset: 30,
            borderRadius: 10,
          },
        ],
      },

      options: {
        animation: {
          animateScale: true,
          animateRotate: true,
        },
        legend: {
          display: false,
        },
        plugins: {
          legend: {
            display: false,
          },
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItem) {
              return tooltipItem.yLabel;
            },
          },
        },
      },
    };
  }
);

onMounted(() => {
  setInterval(() => {
    chart.value.data.datasets[0].data[0] += 3;
    chart.value.data.datasets[0].data[1] += 2;
    chart.value.data.datasets[0].data[2] += 1;
  }, 2000);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("button", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(props.data.table.Waiting) + "%", 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _hoisted_9,
        _createElementVNode("button", _hoisted_10, [
          _createElementVNode("span", _hoisted_11, _toDisplayString(props.data.table.Running) + "%", 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _hoisted_14,
        _createElementVNode("button", _hoisted_15, [
          _createElementVNode("span", _hoisted_16, _toDisplayString(props.data.table.Finished) + "%", 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createVNode(_unref(Vue3ChartJs), _normalizeProps(_guardReactiveProps({ ...chart.value })), null, 16)
    ])
  ]))
}
}

})